import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_SESSIONS_LIST,
  GET_SESSION_DETAILS,
  UPDATE_GROUND_TRUTH,
  UPDATE_GROUND_TRUTH_SUCCESS,
  getSessionsSuccess,
  getSessionsInProgress,
  getSessionsFailed,
  getSessionDetailsSuccess,
  getSessionDetailsInProgress,
  getSessionDetailsFailed,
  updateGroundTruthSuccess,
  updateGroundTruthInProgress,
  updateGroundTruthFailed,
} from './ground-truth-updates.reducer';
import { get } from 'lodash';

import { apiGetSessions, apiGetSessionDetails, apiUpdateGroundTruth } from './ground-truth-updates.api';

function* sagaGetSessions({ payload }) {
  const { page = 1, pageSize = 10 } = payload;
  try {
    yield put(getSessionsInProgress());
    const response = yield call(apiGetSessions, { page, pageSize });
    const sessions = get(response, 'data.sessions');

    yield put(getSessionsSuccess({
      data: { sessions },
    }));
  } catch (error) {
    yield put(getSessionsFailed());
  }
}

function* sagaGetSessionDetails({ payload = {} }) {
  const { sessionId = '' } = payload;
  try {
    if (!sessionId) {
      console.error('Session ID is required to fetch session details.');
      yield put(getSessionDetailsFailed());
      return;
    }

    yield put(getSessionDetailsInProgress());
    const response = yield call(apiGetSessionDetails, { sessionId });
    const sessionDetails = get(response, 'data.sessionDetails');

    yield put(getSessionDetailsSuccess({
      data: { sessionDetails },
    }));
  } catch (error) {
    yield put(getSessionDetailsFailed());
  }
}

function* sagaUpdateGroundTruth() {
  try {
    yield put(updateGroundTruthInProgress());
    const response = yield call(apiUpdateGroundTruth);
    const result = get(response, 'data.result');

    yield put(updateGroundTruthSuccess({
      data: { result },
    }));
  } catch (error) {
    yield put(updateGroundTruthFailed());
  }
}

function* sagaUpdateGroundTruthSuccess({ payload }) {
  try {
    yield put(updateGroundTruthSuccess({
      data: get(payload, 'data', {})
    }));
  } catch (error) {
    yield put(updateGroundTruthFailed());
  }
}

function* sagaGroundTruthUpdates() {
  yield takeLatest(GET_SESSIONS_LIST, sagaGetSessions);
  yield takeLatest(GET_SESSION_DETAILS, sagaGetSessionDetails);
  yield takeLatest(UPDATE_GROUND_TRUTH, sagaUpdateGroundTruth);
  yield takeLatest(UPDATE_GROUND_TRUTH_SUCCESS, sagaUpdateGroundTruthSuccess);
}

export default sagaGroundTruthUpdates;
